module.exports = __webpack_public_path__ + "static/media/spicy.9a75f754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/spicy.svg
// module id = 75
// module chunks = 0